
<div class="breadcrumbs">
  <ul class="breadcrumbs__list">
  <li><a href="javascritp:;">General</a></li>
  <li>Documents</li>
  </ul>
</div>
<main class="page-main">
  <div class="layout layout--central">
    <div class="layout__row">
      <app-landing-left-sidebar></app-landing-left-sidebar>
      <div class="layout__bodycol">
        <header class="central-header d-none d-lg-flex">
           <div class="central-header__title">
              <h3>Documents</h3>
           </div>
        </header>
        <div class="row row--sm row--gap row--mh">
             <div class="col-12 col-md-6 col-lg-4">
                 <a href="javascript:;" [routerLink]="['/' + RouterLinks.PolicyDocuments]"  class="card card--document">
                     <div class="card-body">
                         <div class="card__content">
                             <img src="assets/icn/policy-documents.svg" alt="" class="icon">
                             <h5 class="font-16">Policy documents</h5>
                             <p><small>Transcripts, schedules and wording related to your policies</small></p>
                         </div>
                         <div class="card__caret">
                             <svg class="icon">
                                 <use xlink:href="#chevron-right"></use>
                             </svg>
                         </div>
                     </div>
                 </a>
             </div>
             <div class="col-12 col-md-6 col-lg-4">
                 <a href="javascript:;" [routerLink]="['/' + RouterLinks.DocumentsGeneral]"  class="card card--document">
                     <div class="card-body">
                         <div class="card__content">
                             <img src="assets/icn/general-docs.svg" alt="" class="icon">
                             <h5 class="font-16">General documents</h5>
                             <p><small>Documents related to procedures and practices</small></p>
                         </div>
                         <div class="card__caret">
                             <svg class="icon">
                                 <use xlink:href="#chevron-right"></use>
                             </svg>
                         </div>
                     </div>
                 </a>
             </div>

             <!-- we don't have a listing page for 'Claim transcripts' yet, so hiding this for now 
             <div class="col-12 col-md-6 col-lg-4">
                 <a href="#" class="card card--document">
                     <div class="card-body">
                         <div class="card__content">
                             <img src="/assets/icn/claim-documents.svg" alt="" class="icon">
                             <h5 class="font-16">Claim transcripts</h5>
                             <p><small>Documents related to your submitted and active claims</small></p>
                         </div>
                         <div class="card__caret">
                             <svg class="icon">
                                 <use xlink:href="#chevron-right"></use>
                             </svg>
                         </div>
                     </div>
                 </a>
             </div> 
             -->                   
        </div>
     </div>
    </div>
  </div>
</main>
<app-disclaimer></app-disclaimer>



